import { getDictPhrase } from "../../../common";
export const getEachWayBetStakeInfo = (bet, state) => {
    return getDictPhrase(state.dict, "EachWayStakeInfo").format(bet.numberOfBets, state.formatCurrency(bet.unitStake));
};
//# sourceMappingURL=getEachWayBetStakeInfo.js.map